import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';

export default function ProgramAdd() {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [subdivisions, setSubdivisions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    programId: '',
    programName: '',
    descriptions: '',
  });

  // ------------------------------------------
  // Load Subdivision List
  // ------------------------------------------
  useEffect(() => {
    const fetchSubDivisions = async () => {
      try {
        const firstTiers = await api.getAllFirstThierProgram();
        const ids = firstTiers.map((t) => t.id);
        if (ids.length > 0) {
          const res = await api.getAllSubDivisionOptions({
            programId: ids,
          });
          setSubdivisions(res);
        }
      } catch (err) {
        console.error('Gagal memuat data subdivision:', err);
        showToast('Gagal memuat data subdivision.', 'danger');
      } finally {
        setLoading(false);
      }
    };
    fetchSubDivisions();
  }, [showToast]);

  // ------------------------------------------
  // Handle Input
  // ------------------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  // ------------------------------------------
  // Submit Form
  // ------------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.programId || !form.programName || !form.descriptions) {
      showToast('Harap lengkapi seluruh data sebelum menyimpan.', 'danger');
      return;
    }

    try {
      setSubmitting(true);

      await api.addProgram({
        programId: form.programId,
        programName: form.programName,
        descriptions: form.descriptions,
      });

      showToast('Program berhasil ditambahkan!', 'success');
      navigate('/program');
    } catch (err) {
      console.error(err);
      showToast('Terjadi kesalahan saat menyimpan data.', 'danger');
    } finally {
      setSubmitting(false);
    }
  };

  // ------------------------------------------
  // Render UI
  // ------------------------------------------
  return (
    <div className="container py-4" style={{ maxWidth: '720px' }}>
      {/* Back Button */}
      <div className="mb-3">
        <button
          type="button"
          className="btn btn-white btn-sm rounded-circle shadow-sm border bg-white text-dark d-inline-flex align-items-center justify-content-center"
          style={{ width: '38px', height: '38px' }}
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left fs-5"></i>
        </button>
      </div>

      {/* Header */}
      <div className="mb-4">
        <h3 className="fw-bold">Tambah Program Baru</h3>
        <p className="text-muted">
          Pilih subdivision, tentukan nama program, dan isi deskripsi program yang akan dibuat.
        </p>
      </div>

      <div className="card border-0 shadow-sm rounded-4">
        <div className="card-body p-4">
          {loading ? (
            <div className="text-center py-5">
              <div
                className="spinner-border text-primary"
                style={{ width: '3rem', height: '3rem' }}
                role="status"
              ></div>
              <p className="text-muted mt-3 mb-0">Memuat data subdivision...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="row g-3">
              {/* Select Subdivision */}
              <div className="col-12">
                <label className="form-label fw-semibold">
                  Pilih Subdivision <span className="text-danger">*</span>
                </label>
                <select
                  name="programId"
                  className="form-select rounded-3"
                  value={form.programId}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Pilih Subdivision --</option>
                  {subdivisions.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Program Name */}
              <div className="col-12">
                <label className="form-label fw-semibold">Nama Program <span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="programName"
                  className="form-control rounded-3"
                  value={form.programName}
                  onChange={handleChange}
                  placeholder="Contoh: Internship MSIB Reguler"
                  required
                />
              </div>

              {/* Description */}
              <div className="col-12">
                <label className="form-label fw-semibold">
                  Deskripsi Program <span className="text-danger">*</span>
                </label>
                <textarea
                  name="descriptions"
                  className="form-control rounded-3"
                  rows="4"
                  value={form.descriptions}
                  onChange={handleChange}
                  placeholder="Tuliskan deskripsi singkat mengenai program..."
                  required
                ></textarea>
              </div>

              {/* Buttons */}
              <div className="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-light me-2 rounded-pill"
                  onClick={() => navigate('/program')}
                  disabled={submitting}
                >
                  Batal
                </button>

                <button
                  type="submit"
                  className="btn btn-primary rounded-pill px-4"
                  disabled={submitting}
                >
                  {submitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Menyimpan...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-save me-2"></i>
                      Simpan
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
